import { render, staticRenderFns } from "./CertificationCategoryDetail.vue?vue&type=template&id=571a8adc&scoped=true"
import script from "./CertificationCategoryDetail.vue?vue&type=script&lang=js"
export * from "./CertificationCategoryDetail.vue?vue&type=script&lang=js"
import style0 from "./CertificationCategoryDetail.vue?vue&type=style&index=0&id=571a8adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571a8adc",
  null
  
)

export default component.exports